import { render, staticRenderFns } from "./ResourcesFolderCard.vue?vue&type=template&id=2eb98861&scoped=true&"
import script from "./ResourcesFolderCard.vue?vue&type=script&lang=js&"
export * from "./ResourcesFolderCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesFolderCard.vue?vue&type=style&index=0&id=2eb98861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb98861",
  null
  
)

export default component.exports